import { Component, OnInit } from "@angular/core";
import { MenuItem } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Router } from "@angular/router";
import { USER_TYPES } from "src/app/constant/constant";
import { MedicalProfessionDashboardComponent } from "./medical-profession-dashboard/medical-profession-dashboard.component";
import { UtilitiesService } from "src/app/utilities/utilities.service";
import { TraceClassDecorator } from "@sentry/angular";
import { TokenService } from "src/app/utilities/token.service";
import { ProviderStateService } from "src/app/services/provider-state.service";


@TraceClassDecorator()
@Component({
    selector: "doctor-app-topbar",
    templateUrl: "./app.topbar.component.html",
    styles: [".ui-tabmenuitem.ui-state-active { background-color: #ffffff;}"],
})
export class DoctorAppTopBarComponent implements OnInit {
    readonly userTypes = USER_TYPES;

    // app: any;
    base_url: string = "";
    edit_url: string = "";
    currentRoleID: number = 0;
    slug: string = "";
    medicalProfessionType: string[] = [];
    constructor(
        public app: MedicalProfessionDashboardComponent,
        public DialogService: DialogService,
        private router: Router,
        private utilitiesService: UtilitiesService,
        private readonly tokenUtil: TokenService,
        private readonly providerstateService: ProviderStateService
    ) {

        for (let i = 0; i < Object.keys(this.userTypes).length; i++) {
            this.medicalProfessionType.push(this.userTypes[Object.keys(this.userTypes)[i]]);
        }

        // this.app = this.doctorDashboard;

    }
    display1: boolean = false;
    display: boolean = false;
    display2: boolean = false;
    posting: boolean;
    items: MenuItem[];
    activeItem: MenuItem;
    provider_img: string;
    data;
    is_primary_provider: boolean = false;

    async ngOnInit() {
        this.slug = this.providerstateService.getProviderSlug();
        this.provider_img = this.providerstateService.getLogoUrl();
        this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
        this.currentRoleID = this.tokenUtil.findRoleId();



        // Attempt to get the base URL segment
        this.base_url = this.utilitiesService.getBaseUserURL(this.router.url, 2);


        // Check if base_url is still undefined or empty
        if (!this.base_url) {
            console.error("Base URL could not be determined.");
        }

        // Set edit_url based on currentRoleID
        if (this.currentRoleID == 8 || this.currentRoleID == 9) {
            this.edit_url = "dashboard";
        } else {
            this.edit_url = "edit";
        }

        // Initialize menu items
        this.items = [
            {
                label: "Dashboard",
                icon: "fa fa-fw fa-bar-chart",
                command: () => {
                    this.RouterNavigation("/" + this.base_url + "/dashboard");
                }
            },
            {
                label: "Doctors",
                icon: "pi pi-fw pi-user-plus",
                command: () => {
                    this.openLink('HOMPAGE_BASE_URL', "view-doctors", "eGlobalDoctors-View-All-Doctors");
                }
            },
            {
                label: "Specialties",
                icon: "pi pi-fw pi-plus-circle",
                command: () => {
                    this.openLink('HOMPAGE_BASE_URL', "view-specialties", "eGlobalDoctors-View-All-specialties");
                }
            },
            {
                label: "FAQ",
                command: () => {
                    this.openLink('HOMPAGE_BASE_URL', "faq-doctor", "eGlobalDoctors-View-FAQs");
                }
            },
            {
                label: "Contact Us",
                icon: "pi pi-fw pi-envelope",
                command: () => {
                    this.openLink('HOMPAGE_BASE_URL', "contactus", "eGlobalDoctors-View-Contact-Us");
                }
            }
        ];

        // Add Videos and FMC menu items conditionally
        if (this.base_url === this.userTypes.DOCTOR) {
            this.items.push(
                {
                    label: "Videos",
                    icon: "pi pi-fw pi-desktop",
                    command: () => {
                        this.RouterNavigation("/" + this.base_url + "/doctor-videosection");
                    }
                },
                {
                    label: "FMC",
                    icon: "fa fa-fw fa-user-md",
                    command: () => {
                        this.RouterNavigation("/" + this.base_url + "/Free-Medical-Counseling");
                    }
                }
            );
        }
    }






    RouterNavigation(path: string) {
        this.router.navigate(["/" + this.slug + '/' + path]);
    }


    async openLink(base_url_name, link: string, target: string): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }




}
